/**
 * 描述：微博配置
 * 日期：2017-11-15
 * 作者：Bai.Zhiming
 */
"use strict";
angular.module("weiboConfigModule", []).
directive("weiboConfig", ["$timeout", "trsHttpService", function($timeout, trsHttpService) {
    return {
        restrict: "E",
        replace: true,
        scope: false,
        templateUrl: "./planningCenter/realTimeClues/suddenClues/newsMonitor/weibo/weiboConfig_tpl.html",
        link: function(scope, $elem, $attrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                $timeout(function() {
                    scope.status.showLocation = $elem.find("ul").eq(0).find("li").eq(0).offset().top;
                }, 100);
                getWeiboCliques();
                $elem.find("ul").bind("mousewheel", function(e) {
                    $(this).find("li").each(function() {
                        var theTop = $(this).offset().top;
                        var id = $(this).attr("id");
                        var compare = theTop - scope.status.showLocation;
                        if (id && compare >= -10 && compare < 15) {
                            $timeout(function() {
                                scope.status.selectedLetter = { value: id };
                            });
                        }
                    });
                });
            }
            /**
             * [goTo description] 锚点定位
             * @return {[type]} [description]
             */
            scope.goToAnchor = function(item) {
                if (item.disabled) return;
                scope.status.selectedLetter = item;
                var parentTop = $elem.find("ul").eq(0).offset().top;
                var curLiTop = $elem.find("#" + item.value).offset().top + $elem.find("ul").scrollTop();
                var distance = curLiTop - scope.status.showLocation;
                $elem.find("ul").stop(true, true).animate({
                    scrollTop: distance
                }, 1000, function() {
                    $elem.find("#" + item.value).find("span").addClass("prompt");
                    $timeout(function() {
                        $elem.find(".prompt").removeClass("prompt");
                    }, 2000);
                });
            };
            /**
             * [addAnchor description] 增加锚点定位
             * @param {int} [index] [description] 下标
             */
            scope.addAnchor = function(index) {
                if (index === 0) {
                    return scope.data.weiboCliques[0].firstLetter;
                } else if (scope.data.weiboCliques[index - 1].firstLetter !== scope.data.weiboCliques[index].firstLetter) {
                    return scope.data.weiboCliques[index].firstLetter;
                }
            };
            /**
             * [selectedWeiboCliques description 选择微博集团:选中/未选中]
             * @param  {[type]} group [description]
             * @return {[type]}       [description]
             */
            scope.selectedWeiboCliques = function(clique) {
                if (scope.data.selectedCliques.indexOf(clique) < 0) {
                    scope.data.selectedCliques.push(clique);
                    clique.SELECTED = 1;
                    if (scope.data.weiboCliques.length == scope.data.selectedCliques.length) {
                        scope.status.checkedAll = false;
                    }
                } else {
                    scope.data.selectedCliques.splice(scope.data.selectedCliques.indexOf(clique), 1);
                    clique.SELECTED = 0;
                    scope.status.checkedAll = true;
                }
            };
            /**
             * [initLetter description] 初始化字母 ：数字转字母等
             * @param  {[type]} number [description] 数字
             * @return {[type]}        [description]
             */
            scope.initLetter = function(number) {
                number.value = String.fromCharCode(number.value).toUpperCase();
                var flag = true;
                for (var i = 0; i < scope.data.weiboCliques.length; i++) {
                    var item = scope.data.weiboCliques[i];
                    if (item.firstLetter === number.value) {
                        flag = false;
                        break;
                    }
                }
                number.disabled = flag;
            };
            /**
             * [getWeiboCliques description]初始化右侧微博集团
             * @return {[obj]} [description]
             */
            function getWeiboCliques() {
                var params = {
                    "serviceid": "weibobomb",
                    "modelid": "config"
                };


                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {

                    /*value['pinyin'] = pinyinUtil.getFirstLetter(value.ACCOUNT);
                    newArry.push(pinyinUtil.getFirstLetter(value.ACCOUNT));*/
                    scope.data.weiboCliques = (function(data) {
                        data.sort(function(x, y) {
                            x.firstLetter = pinyinUtil.getFirstLetter(x.ACCOUNT).substring(0, 1);
                            y.firstLetter = pinyinUtil.getFirstLetter(y.ACCOUNT).substring(0, 1);
                            return x.firstLetter.charCodeAt(0) - y.firstLetter.charCodeAt(0);
                        });
                        return data;
                    })(data);

                    for (var i = scope.data.weiboCliques.length - 1; i >= 0; i--) {
                        if (scope.data.weiboCliques[i].SELECTED == 1) {
                            scope.data.selectedCliques.push(scope.data.weiboCliques[i]);
                        }
                    }
                });
            }
        }
    };
}]);